module.exports = __webpack_public_path__ + "media/icon.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/media/brand/icon.svg
// module id = 1165
// module chunks = 0